import React from 'react';
import Link from 'next/link';
import Image from "next/image";
import {useState, useEffect} from 'react';

import {getAuctionItemImg} from '@utils/functions';
import CountdownTimer from '@components/dropAuction/common/CountdownTimer';
import styles from '@styles/dropAuction/dropAuctionLive.module.scss';
import {useApp} from '@context/AppProvider';

const AuctionItemCard = props => {
	const {data} = props;
	const {convertCurrency} = useApp();
	return (
        <div className={`${styles.goItemInner} borderBox borderBoxsAuction`}>
			<div className={styles.listCardTwoColumn}>
				<div className={`${styles.goItemImg} pad15`}>
					<Link
						href={`/product/store/${data.Retailer.shop_url}/${data.Product.slug}`}
					>

                        <div className={styles.image}>
                            <ImageBlock
                                data={{
                                    name: data.Product.product_name,
                                    image: getAuctionItemImg(data),
                                }}
                            />
                        </div>

                    </Link>
				</div>
				<div className={styles.goItemText}>
					<Link
						href={`/product/store/${data.Retailer.shop_url}/${data.Product.slug}`}
					>

                        <div className={styles.timerUpdate}>
                            <CountdownTimer
                                auctionStartTime={data.auction_time_utc}
                                auctionNowTime={data.now}
                                isAuctionStart={false}
                                setDistance={() => {}}
                                isList={true}
                                auctionId={`${data.auction_id}${data.auction_time_utc}`}
                                colorText='peach'
                            />
                        </div>
                        <div className={styles.proAuction}>
                            <div className={styles.proBrand}>
                                {data && data.Product.manufacturer.name}
                            </div>
                            <div className={styles.proName}>
                                {data && data.Product.product_name
                                    ? data.Product.product_name
                                    : ''}
                            </div>
                        </div>

                    </Link>
					<div className={`${styles.priceBox} ${styles.priceInfoMobile}`}>
						<span className='unset'>
							<span className='unset' style={{marginRight: '5px'}}>
								Dropping from
							</span>
							<span className='inlineBlock'>
								{convertCurrency(data && data.base_price.toFixed(2))}
							</span>
						</span>
					</div>
				</div>
			</div>
			<div className={`${styles.priceBox} ${styles.priceInfoDesktop}`}>
				<span className='unset'>
					<span className='unset' style={{marginRight: '5px'}}>
						Dropping from
					</span>
					<span className='inlineBlock'>
						{convertCurrency(data && data.base_price.toFixed(2))}
					</span>
				</span>
			</div>
		</div>
    );
};

function ImageBlock({data}) {
	const [image, setImage] = useState('/img/loading.png');
	useEffect(() => {
		setImage(data.image);
	}, [data.image]);
	return (
        <Image
            src={image}
            alt={data.name}
            placeholder='blur'
            blurDataURL='/img/loading.png'
            onError={e => {
				e.target.style['background-image'] = 'unset';
				setImage('/assets/svg/placeholder.svg');
			}}
            fill
            sizes="100vw"
            style={{
                objectFit: "contain"
            }} />
    );
}

export default AuctionItemCard;
